import angular from 'angular'
import template from './template.html'

function NominasCarganominaasalariadosVincularComponent($dialogParams, dialog, $utils, $dialog, $document, FinanzasTablaRelacional, $session) {
  let $ctrl = this;
  let colorWarn = '#FFECB3';
  let colorError = '#EF9A9A';
  let allow_tablaRelacional = $session.dataTemporal.claims.indexOf('kendu.finanzas.tablaRelacional') >= 0;
  $ctrl.saving = false;
  $ctrl.saved = false;
  $ctrl.groupStatus = {};
  $ctrl.alerts = {
    error: [],
    warning: [],
  };
  $ctrl.companies = $dialogParams['companies'];

  $ctrl.data = $dialogParams['data'].map(function (row, index) {
    let link = row.results.length > 0 ? row.results.map(function (kardex) {
      return Link(row.query[1], kardex);
    }).reduce(function (prev, current) {
      return prev && prev.match < current.match ? current : prev;
    }) : undefined;

    return {
      index: index,
      query: row.query,
      link: link,
      selected: link && (link.match > 0.33),
    };
  }).sort(function (a, b) {
    return a.name > b.name ? 1 : (a.name < b.name ? -1 : 0);
  });

  $ctrl.matchColor = function (row) {
    return row.selected ? (row.link.match >= 0.5 ? '' : colorWarn) : colorError;
  };

  $ctrl.validate = function (row) {
    if (row) {
      row.link.match = 1;
      row.selected = true;
    }
    $ctrl.alerts.error = $ctrl.data.filter(function (row) {
      return !row.selected;
    });
    $ctrl.alerts.warning = $ctrl.data.filter(function (row) {
      return row.link && row.link.match < 0.5;
    });
  };

  $ctrl.validate();

  $ctrl.replace = function (row) {
    $dialog.show('empleado.select', {
      companies: $ctrl.companies,
      searchFor: row.query[1],
    }).then(function (kardex) {
      row.link = Link(row.query[1], kardex);
      row.selected = true;
      $ctrl.validate();

      if (allow_tablaRelacional)
        FinanzasTablaRelacional.set(kardex['ID_Empleado'], kardex['ID_Empresa'], row.query[0], row.query[1], {
          ID_Relacional: row.query[0],
          Nombre_Largo: row.query[1],
          Status: '1',
        });
    });
  };

  $ctrl.discard = function (row) {
    $ctrl.data.splice($ctrl.data.indexOf(row), 1);
    $ctrl.validate();
  };

  $ctrl.discardAlerts = function () {
    $ctrl.data = $ctrl.data.filter(function (row) {
      return row.link;
    });
    $ctrl.validate();
  };

  $ctrl.aproveWarnings = function () {
    $ctrl.alerts.warning.map(function (row) {
      row.link.match = 1;
    });
    $ctrl.validate();
  };

  let currentAlert = {warning: 0, error: 0};
  $ctrl.nextAlert = function (alert) {
    currentAlert[alert] = currentAlert[alert] >= $ctrl.alerts[alert].length ? 0 : currentAlert[alert];
    $document[0].getElementById('row_' + $ctrl.alerts[alert][currentAlert[alert]++].index).scrollIntoView();
  };

  $ctrl.link = function () {
    let data = {};
    let array = [];
    let rows = $ctrl.data;
    rows.forEach(function (row) {
      if (!data[row.link.UID]) {
        data[row.link.UID] = {
          UID: row.link.UID,
          Empleado: row.link.Empleado,
          Empresa: row.link.company,
          ID_Empleado: row.link.ID_Empleado,
          ID_Empresa: row.link.ID_Empresa,
          Data: [],
        };
        array.push(data[row.link.UID]);
      }
      data[row.link.UID].Data.push(row.query);
    });

    dialog.resolve(array);
  };

  $ctrl.cancel = function () {
    dialog.reject();
  };

  function Link(name, kardex) {
    return {
      UID: kardex['ID_Empleado'] + '@' + kardex['ID_Empresa'],
      Empleado: kardex['Nombre_Completo'] || kardex['Empleado'],
      ID_Empresa: kardex['ID_Empresa'],
      ID_Empleado: kardex['ID_Empleado'],
      Status: kardex['Status'],
      company: $ctrl.companies[kardex['ID_Empresa']]['Descripcion'],
      match: $utils.array.compare($utils.string.clear(name).toUpperCase().split(' '), $utils.string.clear(kardex['Nombre_Completo'] || kardex['Empleado']).toUpperCase().split(' ')),
    };
  }
}

angular.module('nominas.carganominaasalariados')
  .controller('NominasCarganominaasalariadosVincular', NominasCarganominaasalariadosVincularComponent)
  .config(($dialogProvider) => {
    $dialogProvider.dialog('nominas.cargaNominaAsalariados.vincular', {
      controller: 'NominasCarganominaasalariadosVincular',
      template: template,
      controllerAs: '$ctrl',
      cancelable: false,
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/carganominaasalariados/components/vincular/component.js